import { ReactNode } from "react";
import { DEFAULT_FIELD_NAMES, FieldNamesType, modeType, DropdownTableOption, DropdownTableValue } from "./interface";

/**
 * 过滤搜索选项
 * @param options 选项
 * @param filterValue 过滤字符串
 * @param fieldNames 字段映射
 * @param searchDiscriminateCase 是否区分大小写
 * @param isChildren 是否为子节点
 * @param parentLabel 父节点label
 * @returns 
 */
export function filterSearchOptions(
  options: DropdownTableOption[],
  filterValue: string,
  fieldNames?: FieldNamesType,
  searchDiscriminateCase?: boolean,
) {
  filterValue = filterValue?.trim();
  if (!filterValue) return options;
  const newOptions: DropdownTableOption[] = [];
  if (Array.isArray(options)) {
    options.forEach(option => {
      const labelName = fieldNames?.label || DEFAULT_FIELD_NAMES.label;
      const label = option[labelName];
      if (searchDiscriminateCase) {
        if (label?.toString().includes(filterValue)) {
          newOptions.push({
            ...option,
            [fieldNames?.label || DEFAULT_FIELD_NAMES.label]: label,
          });
        }
      } else {
        if (label?.toLowerCase?.().includes(filterValue.toLowerCase())) {
          newOptions.push({
            ...option,
            [fieldNames?.label || DEFAULT_FIELD_NAMES.label]: label,
          });
        }
      }
    });
  };
  return newOptions;
}
/**
 * 获取选项对应的label
 * @param flatOptions 拉平后的选项
 * @param value 选项值
 * @returns 
 */
export function getOptionLabel(flatOptions?: DropdownTableOption[], value?: DropdownTableValue, fieldNames?: FieldNamesType) {
  if (value === undefined || value === null) return null;
  const valueName = fieldNames?.value || DEFAULT_FIELD_NAMES.value;
  if (Array.isArray(value)) {
    const filterItems = flatOptions?.filter(item => value.includes(item[valueName]));
    return filterItems?.map(item => {
      if (item) {
        return item[fieldNames?.label || DEFAULT_FIELD_NAMES.label];
      }
    });
  }
  const findItem = flatOptions?.find(item => item[valueName] === value);
  if (findItem) {
    return findItem[fieldNames?.label || DEFAULT_FIELD_NAMES.label];
  }
  return value;
}
/**
 * 获取选项
 * @param flatOptions 拉平后的选项
 * @param value 选项值
 * @returns 
 */
export function getSelectOptions(flatOptions?: DropdownTableOption[], value?: DropdownTableValue, mode?: modeType, fieldNames?: FieldNamesType): DropdownTableOption | DropdownTableOption[] | undefined {
  if (Array.isArray(flatOptions) && value !== undefined) {
    const valueName = fieldNames?.value || DEFAULT_FIELD_NAMES.value;
    if (Array.isArray(value)) {
      const filterItems: DropdownTableOption[] = [];
      value.forEach(item => {
        const findItem = flatOptions.find(v => v[valueName] === item);
        filterItems.push(findItem || {});
      });
      return filterItems;
    }
    const findItem = flatOptions.find(item => item[valueName] === value);
    return findItem;
  }
  return mode === 'multiple' ? [] : undefined;
}
